<template>
  <div class="flex flex-row">
    <select v-model="terminalOperator" class="w-48 mr-2 form-control">
      <option :value="undefined">Inget valt</option>
      <option :value="'000' + i" v-for="i of 9" :key="i">{{ i }}</option>
    </select>

    <button
      class="btn btn-secondary"
      @click="saveTerminalOperator()"
      :disabled="!dirtyTerminalOperator"
    >
      Spara
    </button>
  </div>
</template>

<script>
export default {
  name: 'TerminalOrder',
  props: {
    value: {
      type: Object,
    },
  },
  data() {
    return {
      dirtyTerminalOperator: false,
    }
  },
  computed: {
    terminalOperator: {
      get() {
        return this.value.terminalOperator
      },
      set(val) {
        this.dirtyTerminalOperator = true
        this.value.terminalOperator = val
      },
    },
  },
  methods: {
    async saveTerminalOperator() {
      this.dirtyTerminalOperator = false
      await this.$apollo.mutate({
        mutation: require('../../graphql/UpdateCashregister.gql'),
        variables: {
          data: {
            terminalOperator: this.terminalOperator,
          },
          id: this.value.id,
        },
      })
      this.$notify({
        title: 'OK',
        text: 'Terminalordning uppdaterad',
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>
